module.exports = __webpack_public_path__ + "static/media/boris-profile-img.9166add2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/boris-profile-img.jpg
// module id = 162
// module chunks = 0